import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState();

  // test ui urls
  // const TEST_URL = "https://tmtuerp.in/testwagle";
  const TEST_URL = "https://tmtuerp.in/wagle";

  // test backend urls
  // const TEST_BK_URL = "https://www.tmtuerp.in/BK_WAGLE";
  const TEST_BK_URL = "https://webhook.aeontechhub.com";

  return (
    <StateContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        user,
        setUser,
        TEST_URL,
        TEST_BK_URL,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
